var map = {
	"./1before-destruction.png": 4835,
	"./2bpost destruction2.png": 5405,
	"./3bpost-destruction3.png": 9431,
	"./beam.png": 3156,
	"./gigachad punch dodge.png": 2529,
	"./gigachadhole.png": 1367,
	"./harold hit.png": 1102,
	"./lava-level.png": 920,
	"./mages.png": 829,
	"./newlevel.png": 9354,
	"./planet.png": 1065,
	"./progression.png": 2175
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1190;